module.exports = __webpack_public_path__ + "images/thresholdIcon-681d36.svg";